<template>
  <div>
    <div style="margin-bottom: 10px;">
        <el-radio-group v-model="type" @change="changeSearchType" size="mini">
          <el-radio-button :label="0">按款</el-radio-button>
          <el-radio-button :label="1">按SKU</el-radio-button>
        </el-radio-group>
    </div>
    <div class="table-search">
      <div class="table-search-item">
        <el-date-picker
          v-model="searchForm.operateTime"
          type="datetimerange"
          @input="handleTimeChange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          :picker-options="pickerOptions"
          :clearable="false"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="操作开始时间"
          end-placeholder="操作结束时间"
        />
      </div>
      <div class="table-search-item" v-show="searchType === 0">
        <SearchSelect v-model="searchForm.actions" :items="OPERATION_TYPE" propKey="shopSources" :attrs="{placeholder:'操作类型',width: '150px'}" :isSearch="true" @search="search" />
      </div>
      <div class="table-search-item" v-show="searchType === 0">
        <SearchSelect v-model="searchForm.userIds" :items="shopsAll" propKey="shopSources" :attrs="{placeholder:'平台/店铺名称',width: '200px',multiple:true}" :isSearch="true" @search="search" />
      </div>
      <div class="table-search-item" v-show="searchType === 0">
            <SearchInput v-model="searchForm.outerIds" :attrs="{placeholder:'平台主商家编码',label:'平台主商家编码',dialogDesText:'多个平台主商家编码以英文逗号分割或每行一个',width: '200px',isDialog:true}" @search="search" />
      </div>
      <div class="table-search-item" v-show="searchType === 0">
          <!-- <BaseCombo 
            v-model="searchForm.region" 
            :selectOptions="[{value:1,label:'模糊查询'},{value:2,label:'精确查询'}]"
            :attrs="{placeholder:''}"
          > -->
            <SearchInput v-model="searchForm.kmtItemOuterIds" :attrs="{placeholder:'款式编码',dialogDesText:'多个款式编码以英文逗号分割或每行一个',width: '200px',isDialog:false}" @search="search" />
          <!-- </BaseCombo> -->
      </div>
      <div class="table-search-item">
        <!-- <BaseCombo 
          v-model="searchForm.region" 
          :selectOptions="[{value:1,label:'模糊查询'},{value:2,label:'精确查询'}]"
          :attrs="{placeholder:''}"
        > -->
          <SearchInput v-model="searchForm.numIids" :attrs="{placeholder:'店铺商品ID',width: '200px',dialogDesText:'多个店铺商品ID以英文逗号分割或每行一个',isDialog:true}" @search="search" />
        <!-- </BaseCombo> -->
      </div>
      <div class="table-search-item" v-show="searchType === 1">
          <SearchInput v-model="searchForm.skuId" :attrs="{placeholder:'店铺规格ID',width: '200px',dialogDesText:'多个店铺规格ID以英文逗号分割或每行一个',isDialog:true}" @search="search" />
      </div>
      <div class="table-search-item" v-show="searchType === 0">
        <SearchInput v-model="searchForm.remark" :attrs="{placeholder:'商品名称',width: '150px'}" @search="search" />
      </div>
      <div class="table-search-item">
        <SearchSelect v-model="searchForm.staffId" :items="staffData" :attrs="{placeholder:'操作人',width: '150px'}" :isSearch="true" @search="search" />
      </div>
      <div class="table-search-item">
        <SearchSelect v-model="searchForm.operateStatus" :items="operateStatusItem" :attrs="{placeholder:'操作状态',width: '150px'}" :isSearch="true" @search="search" />
      </div>
      <div class="table-search-item" v-show="searchType === 1">
        <!-- <BaseCombo 
          v-model="searchForm.region" 
          :selectOptions="[{value:1,label:'模糊查询'},{value:2,label:'精确查询'}]"
          :attrs="{placeholder:''}"
        > -->
          <SearchInput v-model="searchForm.skuOuterIds" :attrs="{placeholder:'平台规格商家编码',width: '200px',dialogDesText:'多个平台规格商家编码以英文逗号分割或每行一个',isDialog:true}" @search="search" />
        <!-- </BaseCombo> -->
      </div>
      <div class="table-search-item" v-show="searchType === 1">
        <!-- <BaseCombo 
          v-model="searchForm.region" 
          :selectOptions="[{value:1,label:'模糊查询'},{value:2,label:'精确查询'}]"
          :attrs="{placeholder:''}"
        > -->
          <SearchInput v-model="searchForm.kmtSkuOuterIds" :attrs="{placeholder:'商品编码',width: '200px',isDialog:false}" @search="search" />
        <!-- </BaseCombo> -->
      </div>
      <div class="table-search-item"><el-button @click="search" style="height:100%" type="primary">查询</el-button></div>
      <div class="table-search-item"><el-button @click="clear" style="height:100%">清空</el-button></div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SearchSelect from "@/components/prod/center/components/SearchSelect.vue";
import SearchInput from "@/components/prod/center/components/SearchInput.vue";
import BaseCombo from "@/components/prod/center/components/BaseCombo.vue";
import prod_center_dictionary from "@/components/prod/center/dictionary";
import {getDateStart, getDateEnd, pickerOptions} from "@/pages/supplier/prod/log/util"
import dayjs from 'dayjs';

const initForm = {
  userIds:[],
  outerIds:'',
  operateTime:[dayjs().subtract(7, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss'),dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
  actions:'',
  numIids:'',
  skuId:'',
  remark:'',
  staffId:'',
  skuOuterIds:'',
  operateStatus:'',
}
export default {
  components: {
    SearchSelect,
    SearchInput,
    BaseCombo
  },
  props: {
    searchType:{
      type: Number,
      default: 0
    },
    staffList:{
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      type:0,
      pickerOptions,
      searchForm: {...initForm},
      OPERATION_TYPE:prod_center_dictionary.OPERATION_TYPE,
      operateStatusItem:[{label: '全部', value: -1,},{label: '失败', value: 0,}]
    }
  },
  watch:{
    searchType(val) {
      this.type = val
    }
  },
  created() {

  },
  computed: {
    ...mapGetters(['shops_all']),
    shopsAll() {
      let allShop = this.shops_all
      const shops = allShop.map(shop => ({label: shop.shortTitle || shop.title, value: shop.userId, icon: shop.icon}));
      return shops
    },
    staffData(){
      return this.staffList.map(item => ({label: item.name, value: item.accountId}))
    },
  },
  watch: {
  },
  methods: {
    getParams() {
      const { operateTime,userIds,...reset } = this.searchForm
      let params = {
        ...reset,
        queryType:this.searchType,
        userIds:userIds.join(','),
        startTimestamp:operateTime[0] ? dayjs(operateTime[0]).valueOf() : '',
        endTimestamp:operateTime[1] ? dayjs(operateTime[1]).valueOf() : ''
      }
      return params
    },
    search() {
      this.$emit('search')
    },
    clear() {
      this.searchForm = {...initForm}
      this.search();
    },
    handleTimeChange(){
      this.search();
    },
    changeSearchType(val){
      this.$emit('changeSearchType', val);
    }
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>
.table-search {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;

  &-item {
    margin-right: 8px;
    margin-bottom: 8px;
    line-height: 28px;
  }

}
</style>
